var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 243,
    viewBox: "0 0 187 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5619,
    y: 141.446,
    width: 72,
    height: 72,
    transform: "rotate(12 15.5619 141.446)",
    stroke: "#F01A33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5315,
    y: 71.0197,
    width: 72,
    height: 72,
    transform: "rotate(12 30.5315 71.0197)",
    stroke: "#F01A33"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.958,
    y: 85.9893,
    width: 72,
    height: 72,
    transform: "rotate(12 100.958 85.9893)",
    stroke: "#F01A33"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115.928,
    y: 15.5626,
    width: 72,
    height: 72,
    transform: "rotate(12 115.928 15.5626)",
    stroke: "#F01A33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare2);
export default __webpack_public_path__ + "static/media/square__2.4e9430be631fd17e3f2f1ebeeefce3cf.svg";
export { ForwardRef as ReactComponent };